<footer class="app-footer finanziamento-app-footer">
	@if (showFundingBranding) {
		<div class="finanziamento-app">
			<img class="finanziamento-app-loghi" src="assets/images/finanziamento-regione-abruzzo.svg" alt="Coesione Italia 21-27 Abruzzo · Cofinanziato dall'Unione europea · Repubblica Italiana · Regione Abruzzo" />
			<span class="finanziamento-app-testo small">Progetto finanziato con il contributo della Regione Abruzzo a valere sul PR FESR Abruzzo 2021-2027 · Cofinanziato dall'Unione europea.</span>
			<span class="finanziamento-app-copyright small">
				<button type="button" class="cookie-link" (click)="openCookieSettings()">Cookie Policy</button>
				<span class="finanziamento-app-sep">·</span>
				Copyright &copy; <a href="https://www.kondorcs.it">Kondor CS S.R.L.</a>
			<span class="finanziamento-app-sep">&middot;</span>
			v{{ appVersion }}
			</span>
		</div>
	} @else {
		<span class="finanziamento-app-copyright small">
			<button type="button" class="cookie-link" (click)="openCookieSettings()">Cookie Policy</button>
			<span class="finanziamento-app-sep">·</span>
			Copyright &copy; <a href="https://www.kondorcs.it">Kondor CS S.R.L.</a>
			<span class="finanziamento-app-sep">&middot;</span>
			v{{ appVersion }}
		</span>
	}
</footer>
